import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()
function changeSelect (data) {
  if (data.obj.length === 0) return false
  if (!data.obj[0].value || !data.obj[0].id) {
    data.obj.forEach(item => {
      item.value = item.code
    })
  }
}
const state = {
  /*
   * 费用总表
   */
  allCostList: [],
  allCostMark: 0,
  /*
  * 仓储费
  * */
  warehousingList: {},
  warehousingMark: 0,
  // wareSearchFormInfo: {
  //   ref: null,
  //   data: {
  //     name: '',
  //     type: '',
  //     settlementStatus: '',
  //     beginTime: ''
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // },
  /*
  * 仓储费 - 查看详情
  * */
  wareDetailList: [],
  /*
  * 装卸费
  * */
  handlingGoodsList: [],
  handlingGoodsMark: 0,
  handlingGoodsdetaiList: [],
  // picker: '', // 选择时间
  // settlementStatus: '', // 状态
  // name: '', // 供应商名称
  // beginTime: '', // 筛选开始时间
  // endTime: '', // 筛选结束时间
  // type: '', // 任务类型编码
  /*
  * 配送费
  * */
  runErrandsList: [],
  runErrandsMark: 0,
  costType: '',
  // search: {
  //   picker: '', // 选择时间
  //   settlementStatus: '', // 状态
  //   name: '', // 供应商名称
  //   beginTime: '', // 筛选开始时间
  //   endTime: '', // 筛选结束时间
  //   type: '' // 任务类型编码
  // },
  /*
   * 退货费
   */
  returnCostList: [],
  returnCostMark: 0,
  returnCostDetailList: [],
  /*
  * 贴标费
  * */
  labelCostList: [],
  labelCostMark: 0,
  // labelSearchFormInfo: {
  //   ref: null,
  //   data: {
  //     supplier: '',
  //     goodsName: '',
  //     settlementStatus: '',
  //     beginTime: ''
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // },
  /*
  * 包膜费
  * */
  filmCostList: [],
  filmCostMark: 0,
  // filmSearchFormInfo: {
  //   ref: null,
  //   data: {
  //     supplier: '',
  //     // goodsName: '',
  //     settlementStatus: '',
  //     beginTime: ''
  //   },
  //   rules: {},
  //   labelWidth: '90px'
  // }
  /**
   * 配送仓点列表
   */
  distributionList: {},
  /**
   * 其他费用
   */
  otherDetailList: {},
  OtherCostDetailMark: 0,
  imgURL: [],
  supplierSelect: [] // 下拉框 - 供应商（共用）
}

const actions = {
  // 下拉框 - 供应商（共用）
  [types.SUPPLIERGETLISTS] (context, params) {
    http.fetch('/api/supplier/getAllSupplier', params).then(data => {
      context.commit(types.SUPPLIERGETLISTS, data)
    })
  },
  /**
   * 配送仓点
   */
  [types.GETADISPATCH] (context, params) {
    http.fetch('/api/ycDispatchPlatformPoint/all', params).then(data => {
      context.commit(types.GETADISPATCH, data)
    })
  },
  /*
  * 费用总表
  * */
  // 获取列表
  [types.GETALLCOSTPAGE] (context, params) {
    http.fetch('/api/cost/getAllCostPage', params).then(data => {
      context.commit(types.GETALLCOSTPAGE, data)
    })
  },
  [types.generateCostData] (context, params) {
    http.fetch('/web/yc/cost/generateCostData', params,'application/json').then(data => {
      context.commit(types.generateCostData, data)
    })
  },
  // 导出费用详情
  [types.EXPORTCOSTDETAILS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/cost/exportCostDetails', params, 'application/json', false, {responseType: 'arraybuffer'}).then(data => {
        resolve(data)
      })
    })
  },
  
  /*
  * 仓储费
  * */
  // 获取列表
  [types.GETWAREHOUSEPAGES] (context, params) {
    http.fetch('/api/cost/getWarehousePage', params).then(data => {
      context.commit(types.GETWAREHOUSEPAGES, data)
    })
  },
  // 结算 / 作废 （公用）
  [types.COSTSETTLEMENT] (context, params) {
    let page = params.page
    let settlementStatus = params.settlementStatus
    let codes = params.codes
    let warehouseCode = params.warehouseCode
    http.fetch('/api/cost/settlement', {codes, settlementStatus, warehouseCode}).then(data => {
      context.commit(types.COSTSETTLEMENT, {...data, page, settlementStatus})
    })
  },
  /**
   * 其他费用详情
   */
  [types.OTHERDETATL] (context, params) {
    http.fetch('api/cost/getOtherCostDetail', params).then(data => {
      context.commit(types.OTHERDETATL, data)
    })
  },
  /*
  * 仓储费 - 查看详情
  * */
  // 获取列表
  [types.WAREHOUSEDETAIL] (context, params) {
    http.fetch('/api/cost/getWarehouseCostDetail', params).then(data => {
      context.commit(types.WAREHOUSEDETAIL, data)
    })
  },
  /*
  * 装卸费 / 跑腿费
  * */
  // 获取列表
  [types.GETRUNNINGPAGE] (context, params) {
    state.costType = params.costType
    http.fetch('/api/cost/getRunningPage', params).then(data => {
      context.commit(types.GETRUNNINGPAGE, data)
    })
  },
  // 装卸费 / 跑腿费查看详情
  [types.GETCOSTDETAIL] (context, params) {
    http.fetch('/api/cost/getCostDetail', params).then(data => {
      context.commit(types.GETCOSTDETAIL, data)
    })
  },
  /*
  * 退货费
  * */
  // 获取列表
  [types.GETRETURNPAGE] (context, params) {
    http.fetch('/api/cost/getReturnPage', params).then(data => {
      context.commit(types.GETRETURNPAGE, data)
    })
  },
  // 退货费查看详情
  [types.GETRETURNDETAIL] (context, params) {
    http.fetch('/api/cost/getReturnCostDetail', params).then(data => {
      context.commit(types.GETRETURNDETAIL, data)
    })
  },
  /*
  * 贴标费
  * */
  // 获取列表
  [types.GETLABELPAGE] (context, params) {
    http.fetch('/api/cost/getLabelPage', params).then(data => {
      context.commit(types.GETLABELPAGE, data)
    })
  },
  /*
  * 包膜费
  * */
  [types.GETFILMPAGE] (context, params) {
    http.fetch('/api/cost/getEnvelopeCostPage', params).then(data => {
      context.commit(types.GETFILMPAGE, data)
    })
  },
  /**
   * 新增其他费用
   */
  [types.GETOTHERCOST] (context, params) {
    http.fetch('api/cost/addOtherCost', params).then(data => {
      context.commit(types.GETOTHERCOST, data)
    })
  }
}

const mutations = {
  // 下拉框 - 供应商（共用）
  [types.SUPPLIERGETLISTS] (state, data) {
    changeSelect(data)
    state.supplierSelect = data.obj
  },
  /**
   * 新增其他费用
   */
  [types.GETOTHERCOST] (state, data) {
    if (data.code === 200) {
      state.OtherCostDetailMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  /**
   * 配送仓点列表
   */
  [types.GETADISPATCH] (state, data) {
    console.log(data, '配送仓点列表')
    state.distributionList = data.obj
  },
  /*
  * 费用总表
  * */
  // 获取列表
  [types.GETALLCOSTPAGE] (state, data) {
    console.log(data, '费用总表列表')
    state.allCostList = data
  },
  [types.generateCostData] (state, data) {
    // console.log(data, '费用总表列表')
    state.allCostList = data
  },
  
  /*
  * 仓储费
  * */
  // 获取列表
  [types.GETWAREHOUSEPAGES] (state, data) {
    state.warehousingList = data
  },
  // 结算 / 作废 （公用）
  [types.COSTSETTLEMENT] (state, data) {
    switch (data.page) {
      case 0:
        // 仓储费
        state.warehousingMark = 1
        break
      case 1:
        // 装卸费
        state.handlingGoodsMark = 1
        break
      case 2:
        // 配送费
        state.runErrandsMark = 1
        break
      case 3:
        // 退货费
        state.returnCostMark = 1
        break
      case 4:
        // 贴标费
        state.labelCostMark = 1
        break
      case 5:
        // 包膜费
        state.filmCostMark = 1
        break
      // case 6:
      //   // 其他费用
      //   state.OtherCostDetailMark = 1
      //   break
      default:
        // 费用总表
        state.allCostMark = 1
        break
    }
    if (data.settlementStatus === 3) {
      if (data.code === 200) {
        if (data.obj) {
          vue.$message.warning('账单生成成功，且对账单已发送至供应商邮箱。')
        } else {
          vue.$message.warning('账单已生成，但对账单发送邮箱失败，请检查供应商邮箱设置。')
        }
      } else {
        vue.$message.warning(data.message)
      }
    } else {
      vue.$message({
        showClose: true,
        message: '作废成功',
        type: 'success'
      })
    }
  },
  /*
  * 仓储费 - 查看详情
  * */
  // 获取列表
  [types.WAREHOUSEDETAIL] (state, data) {
    if (!data.rows) {
      data.rows = data.obj
    }
    state.wareDetailList = data
  },
  /*
  * 其他费用 - 查看详情
  * */
  // 获取列表
  [types.OTHERDETATL] (state, data) {
    state.otherDetailList = data.obj[0]
  },
  /*
  * 装卸费 / 跑腿费
  * */
  // 获取列表
  [types.GETRUNNINGPAGE] (state, data) {
    if (data.rows.length) {
      if (state.costType === 'COST_PRO_SEND') {
        state.runErrandsList = data
      } else if (state.costType === 'COST_PRO_MOVE') {
        state.handlingGoodsList = data
      }
      // console.log(data, 'state.runErrandsList')
    } else {
      if (state.costType === 'COST_PRO_SEND') {
        state.runErrandsList = []
      } else if (state.costType === 'COST_PRO_MOVE') {
        state.handlingGoodsList = []
      }
    }
  },
  // 装卸费 / 配送费查看详情
  [types.GETCOSTDETAIL] (state, data) {
    state.handlingGoodsdetaiList = data.obj
    console.log(data, '装卸费 / 配送费查看详情')
  },
  /*
  * 退货费
  * */
  // 获取列表
  [types.GETRETURNPAGE] (state, data) {
    console.log(data, '退货费列表')
    state.returnCostList = data
  },
  // 退货费查看详情
  [types.GETRETURNDETAIL] (state, data) {
    state.returnCostDetailList = data.obj
    console.log(data, '退货费查看详情')
  },
  /*
  * 贴标费
  * */
  // 获取列表
  [types.GETLABELPAGE] (state, data) {
    console.log(data, '贴标费列表')
    state.labelCostList = data
  },
  /*
  * 包膜费
  * */
  // 获取列表
  [types.GETFILMPAGE] (state, data) {
    console.log(data, '包膜费列表')
    state.filmCostList = data
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/costMenu/index.js